module.exports = __webpack_public_path__ + "static/salary_icon-47063e330ad163769ba99bff47964175.svg";